import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ToggleComponent } from './toggle.component'
import { AnalyticsModule } from 'src/app/shared/analytics/analytics.module'
import { SvgModule } from '../../shared/svg/svg.module'
import { ImageModule } from '../image/image.component.module'

@NgModule({
  declarations: [ToggleComponent],
  imports: [CommonModule, AnalyticsModule, SvgModule, ImageModule],
  exports: [ToggleComponent]
})
export class ToggleModule {}
